import React, { useRef } from 'react';
import { ShowIf } from '@apply/components';
import { AccountHolder } from './components/AccountHolder';
import { PhoneNumber } from './components/PhoneNumber';
import { EmailAddress } from './components/EmailAddress';
import { BillingAddress } from './components/BillingAddress/BillingAddress';
import { TransactionDetails } from './components/TransactionDetails/TransactionDetails';
import { isMobileScreen } from '@apply/ui';
import { PropertyInArizona } from './components/PropertyInArizona';
import { PropertyInArizonaWarning } from './components/PropertyInArizonaWarning';
import { PaymentInfoButtonPanel } from './components/PaymentInfoButtonPanel/PaymentInfoButtonPanel';
import { CustomPaymentStep } from '../../constants/CustomPaymentStep';
import { ValidationGroup } from 'devextreme-react/validation-group';

interface PaymentInfoProps {
    customPaymentGuid: string;
    nextDisabled: boolean;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
}

export const PaymentInfo: React.FC<PaymentInfoProps> = ({ customPaymentGuid, nextDisabled, set_paymentStep }) => {
    const mobileScreen = isMobileScreen();
    const validationGroupRef = useRef(null);

    return (
        <>
            <ValidationGroup ref={validationGroupRef}>
                <div className='customPayment-paymentInfo'>
                    <AccountHolder
                        customPaymentId={customPaymentGuid}
                        required={true}
                    />
                    <div className={`customPayment-flexRowContent ${mobileScreen ? 'mobile' : ''}`}>
                        <PhoneNumber
                            customPaymentId={customPaymentGuid}
                            required={true}
                        />
                        <EmailAddress
                            customPaymentId={customPaymentGuid}
                            required={true}
                        />
                    </div>
                    <BillingAddress customPaymentId={customPaymentGuid} />
                    <PropertyInArizona customPaymentId={customPaymentGuid} />
                    <TransactionDetails customPaymentId={customPaymentGuid} />
                    <ShowIf showIf={nextDisabled}>
                        <PropertyInArizonaWarning />
                    </ShowIf>
                    <PaymentInfoButtonPanel
                        nextDisabled={nextDisabled}
                        set_paymentStep={set_paymentStep}
                        validationGroupRef={validationGroupRef}
                    />
                </div>
            </ValidationGroup>
        </>
    );
};
